import axios from "axios";
import Config from "../../Config";

class BranchService {
  static baseUrl = `${Config.backendDomain}vendor/`;
  static getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BranchService.getToken()}`,
      },
    };
  }
  static getToken() {
    return localStorage.getItem("dealboxx_token");
  }
  async getBranches() {
    try {
      const response = await axios.get(
        `${BranchService.baseUrl}vendor_branch`,
        BranchService.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response.data.data.reason || "Failed to fetch branches",
      };
    }
  }

  async addBranch(payload) {
    try {
      const response = await axios.post(
        `${BranchService.baseUrl}vendor_branch`,
        payload,
        BranchService.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.message ||
          "Failed to add branch",
      };
    }
  }

  async getBranchDetails(branch_slug) {
    try {
      const response = await axios.get(
        `${BranchService.baseUrl}vendor_branch/${branch_slug}`,
        BranchService.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.message ||
          "Failed to fetch branch details",
      };
    }
  }

  async updateBranch(branch_slug, payload) {
    try {
      const response = await axios.put(
        `${BranchService.baseUrl}vendor_branch/${branch_slug}`,
        payload,
        BranchService.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.message ||
          "Failed to update branch",
      };
    }
  }

  async deleteBranch(branch_slug) {
    try {
      const response = await axios.delete(
        `${BranchService.baseUrl}vendor_branch/${branch_slug}`,
        BranchService.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason,
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.message ||
          "Failed to delete branch",
      };
    }
  }
}
const branchService = new BranchService();
export default branchService;
